import client from '@/utils/apolloClient';
import { ApolloProvider } from '@apollo/client';
import '@/styles/globals.css';
import type { AppLayoutProps } from 'next/app';
import { CLIENT_ENV } from '@/config/configuration';
import Script from 'next/script';
import { initStoryblok } from '@/storyblok/utils/storyblok';
import packageJson from '@/../package.json';
import { LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER } from '@/costants';
import { plusJakartaSansFont } from '@/styles/fonts';

initStoryblok();

const DefaultLayout = (page: React.ReactNode) => {
  return <>{page}</>;
};

const App = ({ Component, pageProps }: AppLayoutProps) => {
  // Source https://nextjs.org/docs/pages/building-your-application/routing/pages-and-layouts#per-page-layouts
  const getLayout = Component.getLayout || DefaultLayout;
  const isProd = CLIENT_ENV().NODE_ENV === 'production' && CLIENT_ENV().NEXT_PUBLIC_ENV === 'production';

  return (
    <ApolloProvider client={client}>
      {isProd && (
        <>
          <Script
            id="gtm-script"
            dangerouslySetInnerHTML={{
              __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-5WRRVVN');`,
            }}
          ></Script>
          {/* Conversioni numero di telefono:https://app.shortcut.com/davincisalute/story/50760/google-ads-offline-conversion-tracking */}
          <Script
            id="gtag-script"
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-11124570604');`,
            }}
          ></Script>
          <Script
            id="gtag-phone-conversion-number"
            dangerouslySetInnerHTML={{
              __html: `gtag('config', 'AW-11124570604/yASVCOLcpPkYEOzzzbgp', {
                  'phone_conversion_number': '${LISTING_PAGE_FORMATTED_CALLCENTER_TELEPHONE_NUMBER}',
                  })`,
            }}
          ></Script>
          <Script
            id="sentry-loader-script"
            src="https://js.sentry-cdn.com/e9eead9c264a4f21b10c787b1a7b29da.min.js"
            crossOrigin="anonymous"
          />
          <Script
            id="sentry-init"
            dangerouslySetInnerHTML={{
              __html: `document.getElementById("sentry-loader-script").addEventListener("load", () => {
                Sentry.init({
                  environment: '${CLIENT_ENV().NEXT_PUBLIC_ENV}',
                  tracesSampleRate: 0.7,
                  release: '${packageJson.name}@${packageJson.version}',
                  ignoreErrors: [
                    '/\bbannerXclose\b/i'
                  ]
                })
              })`,
            }}
          />
        </>
      )}

      <div className={`${plusJakartaSansFont.variable} font-sans`} id="app">
        {getLayout(<Component {...pageProps} />)}
        {isProd && (
          <>
            <noscript
              dangerouslySetInnerHTML={{
                __html: `iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5WRRVVN"
            height="0" width="0" style="display:none;visibility:hidden"`,
              }}
            ></noscript>
            <noscript
              dangerouslySetInnerHTML={{
                __html: `iframe src="https://www.googletagmanager.com/gtag/js?id=AW-11124570604"
            height="0" width="0" style="display:none;visibility:hidden"`,
              }}
            ></noscript>
          </>
        )}
      </div>
    </ApolloProvider>
  );
};

export default App;
